import API from '../../../API/api';
import { receiveAdShippingData, receiveAdShippingFail, receiveShippingData, receiveShippingFail } from '../../actions/shipping_fees_actions';
import { shippingFeesStarted, shippingFeesSuccess, shippingFeesFailed, shippingAdFeesStarted, shippingAdFeesFailed, shippingAdFeesSuccess } from '../../actions/http_request/shipping_fees_actions';
import ErrorCodes from '../../../_constants/error_codes';
import CatalogContainersConstants from '../../../_pages/catalog/initialize_page_modules/catalog_container_constants';
import { init as initCatalogAdsRevamp } from '../../../_views/catalog_ads/catalog_revamp_ads';

const { store } = TYROOLA.globals;
const errorCodesToCatch = [
    ErrorCodes.REQUEST_TIMEOUT,
    ErrorCodes.TOO_MANY_REQUESTS,
    ErrorCodes.NETWORK_READ_TIMEOUT,
    ErrorCodes.GATEWAY_TIMEOUT,
];

/**
 * @param products
 * @param quantity
 * @param retries
 * @returns {*}
 */
function shippingRequest(products, quantity, retries) {
    'use strict';

    const data = {
        'shippableProducts': getShippableProducts(products, quantity),
        'addressShipping': getAddressShipping()
    };
    const jsonData = JSON.stringify(data);

    if (['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(store) >= 0) {
        shippingFeesStarted();
        return API.POST({
            apiPath: '/api/v2/products/shipping/compute/',
            data: jsonData,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).catch(response => {
            if (retries > 0 && errorCodesToCatch.indexOf(response.status) >= 0) {
                setTimeout(() => {
                    return shippingRequest(products, quantity, retries - 1);
                }, 1000);
            } else {
                shippingFeesFailed();
                receiveShippingFail(response);
            }
        }).done(response => {
            shippingFeesSuccess();
            receiveShippingData(response);
        });
    }
}

/**
 * @param products
 * @param quantity
 * @param retries
 * @returns {*}
 */
export function shippingAdRequest(products, quantity, retries) {
    'use strict';

    const data = {
        'shippableProducts': getShippableProducts(products, quantity),
        'addressShipping': getAddressShipping()
    };
    const jsonData = JSON.stringify(data);

    if (['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(store) >= 0) {
        shippingAdFeesStarted();
        return API.POST({
            apiPath: '/api/v2/products/shipping/compute/',
            data: jsonData,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).catch(response => {
            if (retries > 0 && errorCodesToCatch.indexOf(response.status) >= 0) {
                setTimeout(() => {
                    return shippingRequest(products, quantity, retries - 1);
                }, 1000);
            } else {
                shippingAdFeesFailed();
                receiveAdShippingFail(response);
            }
        }).done(response => {
            shippingAdFeesSuccess();
            receiveAdShippingData(response);

            const catalogRevampAdsContainer = document.getElementById(CatalogContainersConstants.CMS_ADS_CONTAINER_ID);
            if (catalogRevampAdsContainer) {
                const metroArea = TYROOLA.initialFluxStates.metroArea;
                const showShowDetailsButton = TYROOLA.initialFluxStates.showShowDetailsButton;
                const staticUrl = TYROOLA.globals.staticUrl;
                const catalogAdsOptions = { productType: 'tyre', metroArea, showShowDetailsButton, staticUrl };
                initCatalogAdsRevamp(catalogRevampAdsContainer, catalogAdsOptions);
            }
        });
    }
}

/**
 * @param products
 * @param quantity
 * @returns {*}
 */
function getShippableProducts(products, quantity) {
    'use strict';

    return products.map((product, index) => {
        return {
            'productCode': product.sku,
            'quantity': quantity[index]
        };
    });
}

/**
 * @returns {{addressType: string}}
 */
function getAddressShipping() {
    'use strict';

    const addressTypeEnum = Object.freeze({
        RESIDENTIAL: 'residential',
        BUSINESS: 'business'
    });

    return {
        'addressType': addressTypeEnum.BUSINESS
    };
}

export default shippingRequest;